import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  featureheading: {
    margin: theme.spacing(10, 0, 3),
    alignItems: 'baseline',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
    },
  },
  featureLink: {
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right',
      alignSelf: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  section: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column nowrap',
  },
  sectionHeading: {
    textAlign: 'center',
  },
  sectionDescription: {
    margin: theme.spacing(2, 0),
    textAlign: 'center',
    display: 'flex',
  },
  calculatorSection: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
      flexDirection: 'column',
    },
  },
  iconListsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
    },
  },
  productInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: '80px',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(3),
      flexDirection: 'column',
      '& > div': {
        width: '100% !important',
      },
    },
  },
}))
